import request from '../utils/request';

/**
 * 清空流程
 */
export const clearUserProgress = () => {
  return request.post(`/app-api/api/treatment/clear_user_progress`);
};

/**
 * 获取活动分类下的子集
 */
export const dictDataType = (type) => {
  return request.get(`/app-api/system/dict-data/type?type=${type}`);
};

// 结束任务
export const complateTask = (taskId) =>{
  return request.post(`/app-api/api/treatment/dayitem/${taskId}/complete`);
}